import React from "react";
import { ColumnConfig } from "grommet";

export const EmsColumns: ColumnConfig<{
  id: string;
  name: string;
}>[] = [
  {
    property: "id",
    header: "ID",
    primary: true,
    search: true,
    render: (item) => {
      return <div className="cell-container">{item.id}</div>;
    },
  },
  {
    property: "name",
    header: "Name",
    primary: true,
    render: (item) => {
      return <div className="cell-container">{item.name}</div>;
    },
  },
];
